<template>
  <div class="cu-contact-us-drawer">
    <!-- 遮罩层 -->
    <div 
      v-if="show || isClosing"
      class="cu-modal-backdrop" 
      :class="{ 'cu-show': show && !isClosing }"
      @click="handleBackdropClick"
    ></div>

    <!-- 抽屉容器：包含按钮和表单 -->
      <div 
        ref="drawer"
        class="cu-drawer-container"
        :class="{ 'cu-drawer-open': show }"
        :data-hide-button="hideButton"
      >
      <button 
        v-if="!hideButton"
        type="button" 
        class="cu-drawer-handle"
        ref="handle"
        @click="handleToggle"
        t_label="btn_emp2_ContactUs_Drawer"
      >
        <img 
          src="https://cdn.adsalecdn.com/EMP/2-0/images/Chat.svg" 
          alt="chat" 
          class="cu-chat-icon"
        />
        <span class="cu-btn-text">{{ $t('lbl_emp2_ContactUs') }}</span>
      </button>

      <div 
        v-show="show || isClosing"
        class="cu-drawer-content"
        ref="drawerContent"
      >
        <div class="cu-vanilla-modal-content">
          <!-- Loading 遮罩 -->
          <div class="cu-overlay-contact-us" v-if="loading">
            <div class="cu-loading-center">
              <div class="cu-spinner-border" role="status">
                <span class="cu-sr-only">Loading Data</span>
              </div>
            </div>
          </div>

          <!-- 表单 -->
          <ContactUsForm
            :form-data="formData"
            :reason-options="reasonOptions"
            :country-options="countryOptions"
            :submitting="submitting"
            :simple="simple"
            @update:formData="$emit('update:formData', $event)"
            @submit="$emit('submit')"
            @close="$emit('close')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactUsForm from './ContactUsForm.vue';

export default {
  name: 'ContactUsDrawer',
  components: {
    ContactUsForm
  },
  data() {
    return {
      isClosing: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      required: true
    },
    reasonOptions: {
      type: Array,
      default: () => []
    },
    countryOptions: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitting: {
      type: Boolean,
      default: false
    },
    hideButton: {
      type: Boolean,
      default: false
    },
    simple: {
      type: Boolean,
      default: false
    }
  },
    watch: {
    show(newVal) {
      if (newVal) {
        this.isClosing = false;
        this.$nextTick(() => {
          this.openDrawerAnimation();
        });
      } else {
        this.closeDrawerAnimation();
      }
    }
  },
  mounted() {
    // CSS 已经处理了定位，不需要 JavaScript 计算
  },
  beforeDestroy() {
    // 清理工作
  },
  methods: {
    handleBackdropClick() {
      if (this.submitting || this.loading) {
        return;
      }
      this.$emit('close');
    },
    setContentFixedHeight(content) {
      if (content) {
        const isMobile = window.innerWidth <= 768;
        if (this.simple || isMobile) {
          // 移动端：自适应高度，不填满整个屏幕
          content.style.height = isMobile ? 'auto' : '';
          content.style.minHeight = isMobile ? 'auto' : '';
          content.style.maxHeight = isMobile ? '90vh' : '';
        } else {
        }
      }
    },
    clearContentFixedHeight(content) {
      if (content) {
        content.style.height = '';
        content.style.minHeight = '';
        content.style.maxHeight = '';
      }
    },
    handleToggle() {
      if (this.show) {
        this.$emit('close');
      } else {
        this.$emit('open');
      }
    },
    openDrawerAnimation() {
      const drawer = this.$refs.drawer;
      const content = this.$refs.drawerContent;
      if (!drawer) {
        return;
      }
      
      const isMobile = window.innerWidth <= 768;
      
      this.setContentFixedHeight(content);
      
      if (this.hideButton && !isMobile) {
        drawer.style.width = '0';
        const targetWidth = 510;
        const openAnimation = drawer.animate([
          { width: '0px' },
          { width: `${targetWidth}px` },
        ], {
          duration: 280,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
          fill: 'forwards',
        });
        openAnimation.onfinish = () => {
          drawer.style.width = `${targetWidth}px`;
        };
        document.body.classList.add('cu-modal-open');
        return;
      }

      const computedStyle = window.getComputedStyle(drawer);
      let currentWidth = parseFloat(computedStyle.width) || (this.hideButton ? 510 : (isMobile ? 50 : 60));
      const targetWidth = isMobile ? '100vw' : '510px';
      
      const openAnimation = drawer.animate([
        { width: currentWidth + 'px' },
        { width: targetWidth }
      ], {
        duration: 300,
        easing: 'linear',
        fill: 'forwards'
      });

      openAnimation.onfinish = () => {
        drawer.style.width = targetWidth;
      };

      document.body.classList.add('cu-modal-open');
    },
    closeDrawerAnimation() {
      const drawer = this.$refs.drawer;
      const content = this.$refs.drawerContent;
      if (!drawer) {
        return;
      }
      
      const isMobile = window.innerWidth <= 768;

      if (this.hideButton && !isMobile) {
        this.isClosing = true;
        this.setContentFixedHeight(content);
        const currentWidth = parseFloat(window.getComputedStyle(drawer).width) || 510;
        const animation = drawer.animate([
          { width: `${currentWidth}px` },
          { width: '0px' },
        ], {
          duration: 280,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
          fill: 'forwards',
        });
        animation.onfinish = () => {
          this.isClosing = false;
          drawer.style.width = '0';
          this.clearContentFixedHeight(content);
          document.body.classList.remove('cu-modal-open');
        };
        return;
      }
      
      // 移动端且hideButton为true时，直接隐藏，不需要动画
      if (this.hideButton && isMobile) {
        drawer.style.display = 'none';
        this.clearContentFixedHeight(content);
        this.isClosing = false;
        document.body.classList.remove('cu-modal-open');
        return;
      }
      
      this.setContentFixedHeight(content);
      this.isClosing = true;
      
      const currentWidth = parseFloat(window.getComputedStyle(drawer).width) || 510;
      const buttonWidth = this.hideButton ? '510px' : (isMobile ? '50px' : '60px');
      
      const animation = drawer.animate([
        { width: currentWidth + 'px' },
        { width: buttonWidth }
      ], {
        duration: 300,
        easing: 'linear',
        fill: 'forwards'
      });

      animation.onfinish = () => {
        this.isClosing = false;
        drawer.style.width = buttonWidth;
        if (this.hideButton && isMobile) {
          drawer.style.display = 'none';
        }
        this.clearContentFixedHeight(content);
        document.body.classList.remove('cu-modal-open');
      };
    },
    // 定位已由 CSS 处理，不再需要这些方法
  }
};
</script>

<style scoped>
.cu-contact-us-drawer {
  position: relative;
}

.cu-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0;
  transition: opacity 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.cu-modal-backdrop.cu-show {
  opacity: 0.45;
}

.cu-drawer-container[data-hide-button="true"]:not(.cu-drawer-open) {
  width: 0 !important;
  overflow: hidden;
}

.cu-drawer-container {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 1042;
  box-sizing: border-box;
  width: 60px;
  overflow: visible;
  pointer-events: none;
  margin: 0;
  padding: 0;
}

.cu-drawer-handle,
.cu-drawer-content {
  pointer-events: auto;
}
.cu-drawer-handle {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 90px;
  padding: 1rem;
  margin: 0;
  gap: 4px;
  background: #5D4D8C;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  flex-shrink: 0;
  align-self: center;
  box-sizing: border-box;
  z-index: 1042;
  transition: background 0.3s;
}

.cu-drawer-handle:hover {
  background: #4a3d6f;
}

.cu-chat-icon {
  display: block;
  margin: auto;
  margin-left: 5px;
  margin-right: 5px;
  width: 40px; /* 桌面端图标尺寸 */
  height: auto; /* 自动高度，保持原始宽高比，避免变形 */
  max-width: none;
  object-fit: contain; /* 保持图标原始比例 */
}

.cu-btn-text {
  display: block;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 1.2;
  text-align: center;
  white-space: normal;
  word-wrap: break-word;
}

.cu-drawer-content {
  width: 450px;
  height: auto;
  min-height: 300px;
  max-height: 90vh;
  background: #F8F8F8;
  border-radius: 5px 0 0 5px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-self: center;
  position: relative;
  margin-left: auto;
  z-index: 1044;
  visibility: visible;
  opacity: 1;
}


.cu-vanilla-modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 90vh;
  overflow: hidden;
}

.cu-overlay-contact-us {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
}

.cu-loading-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.cu-spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: cu-spinner-border 0.75s linear infinite;
}

@keyframes cu-spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.cu-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

body.cu-modal-open {
  overflow: hidden;
}

@media (max-width: 768px) {
  .cu-drawer-container {
    right: 0 !important;
    top: 50% !important;
    left: auto !important;
    bottom: auto !important;
    height: auto !important;
    width: 50px !important;
    margin: 0 !important;
    padding: 0 !important;
    transform: translateY(-50%) !important;
    pointer-events: none !important;
    z-index: 1042 !important;
  }
  
  /* 有按钮的情况（login页面） */
  .cu-drawer-container.cu-drawer-open {
    width: 100vw !important;
    top: 50% !important;
    bottom: auto !important;
    height: auto !important;
    max-height: 90vh !important;
    transform: translateY(-50%) !important;
  }
  
  /* hideButton为true时（MyUsers页面），初始状态应该隐藏 */
  .cu-drawer-container[data-hide-button="true"]:not(.cu-drawer-open) {
    display: none !important;
  }
  
  .cu-drawer-container[data-hide-button="true"].cu-drawer-open {
    display: flex !important;
    width: 100vw !important;
    right: 0 !important;
    top: 50% !important;
    bottom: auto !important;
    height: auto !important;
    max-height: 90vh !important;
    left: auto !important;
    transform: translateY(-50%) !important;
  }
  
  
  .cu-drawer-handle {
    width: 50px !important;
    max-width: 50px !important;
    min-width: 50px !important;
    height: 70px !important;
    font-size: 12px;
    padding: 8px 2px !important;
    margin: 0 !important;
    border-radius: 5px !important;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
    flex-shrink: 0;
    align-self: center;
    cursor: pointer !important;
    pointer-events: auto !important;
    z-index: 1043 !important;
    position: relative !important;
    touch-action: manipulation !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: flex-start !important;
  }
  
  .cu-chat-icon {
    margin: 0 auto !important;
    padding: 0 !important;
    width: 32px !important;
    height: auto;
    object-fit: contain;
    flex-shrink: 0;
  }
  
  .cu-btn-text {
    margin: 0 !important;
    padding: 0 !important;
    width: 100%;
    font-size: 12px !important;
    line-height: 1.2;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  
  .cu-drawer-content {
    width: 100vw !important;
    height: auto !important;
    max-height: 90vh !important;
    border-radius: 8px 0 0 8px !important;
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    z-index: 1044 !important;
    position: relative !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }
  
  .cu-vanilla-modal-content {
    height: auto !important;
    max-height: 90vh !important;
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    overflow: hidden !important;
  }
}
</style>


